// extracted by mini-css-extract-plugin
module.exports = {"quill":"style_quill__3r-Ys"};